export default "__VITE_ASSET__CrVH70u5__"